/**
 * Converts a java-serialized unix timestamp to short date format
 * Example: 1513194947000 => 01/15/17
 *
 * @param  {String} value the timestamp to convert
 * @return {String}
 */
import moment from 'moment';
import _ from 'lodash';

export default function shortDate(value) {
  if (!value || !_.isNumber(value)) {
    return '';
  }
  var date = new Date(value);
  return moment(date).format('MM/DD/YY');
}
